export default {
  setNews(state, news) {
    state.news = news;
  },
};
